import { Stack } from "@mui/material";

export interface AppLayoutWrapperMobileProps {
  children: React.ReactNode;
}

export function AppLayoutWrapperMobile(props: AppLayoutWrapperMobileProps) {
  const { children } = props;

  return (
    <Stack height="100vh" sx={{ paddingTop: "env(safe-area-inset-top)" }}>
      {children}
    </Stack>
  );
}
